//Facets
import FacetContainer from "./facets/components/facet-sort-container";
import FacetModal from "./facets/components/facet-modal";

//Map
import DrhMapWrapper from "./map/components/map/google-map-wrapper";

//Results
import ResultListContainer from "./results/components/result-list/result-list-container";

//Mobile
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";

//Managers
import AppManager from "./system/components/app/app-manager";
import { useAppDispatch } from "./system/redux/hooks/redux-store-hooks";
import {
	setIsMobile,
	setReRenderMap,
} from "./system/redux/slices/app-status-slice";

//Selectors
import { useAppSelector } from "./system/redux/hooks/redux-store-hooks";
import { selectIsQmiFinder } from "./system/redux/selectors/select-is-qmi-finder";

function App() {
	const dispatch = useAppDispatch();
	const isQmiFinder = useAppSelector(selectIsQmiFinder);

	//Mobile Detection
	const isDesktop = useMediaQuery({
		query: "(min-width: 1280px)",
	});

	const isMobile = useMediaQuery({
		query: "(max-width: 1280px)",
	});

	useEffect(() => {
		dispatch(setIsMobile(isMobile));
		dispatch(setReRenderMap(true));
	}, [isMobile, isDesktop]);

	return (
		<>
			<AppManager />

			<div
				className="CoveoSearchInterface Coveostate CoveoComponentState CoveoComponentOptions CoveoQueryController CoveoHistoryController CoveoDebug coveo-after-initialization"
				style={{ display: "block" }}
			>
				<div className={isDesktop ? "desktopFinder" : "mobileFinder"}>
					<div
						id="CoveoSearchResults"
						className="CoveoPromos frame results community-results"
					>
						{isDesktop && (
							<>
								<DrhMapWrapper />

								<div className="community-set">
									<FacetContainer />
									<ResultListContainer />
								</div>
							</>
						)}
						{isMobile && (
							<div className="community-set">
								<DrhMapWrapper />
								<ResultListContainer />
							</div>
						)}
					</div>

					<FacetModal />
				</div>
			</div>
			{isQmiFinder && 
				<dialog className="modal calc" id="mpcModal">
					 <div id="dialogContent" className="dialog-content mfp-close-btn-in">
            			<div><b>How Estimated Monthly Payment Is Calculated</b></div>
            			<iframe id="mpc-iframe" src="" loading="lazy" style={{ border: "0", position: "relative", height: "800px", width: "100%", overflow: "visible" }}></iframe>
            			<button title="Close (Esc)" type="button" id="mpc-iframe-close-button" className="mfp-close focus firstone lastone">×</button>
       				 </div>
				</dialog>
			}
		</>
	);
}

export default App;
